export var lottieTheme = {
  baseStyle: _ref => {
    var {
      height,
      width
    } = _ref;
    return {
      height,
      width
    };
  },
  defaultProps: {
    height: '340px',
    width: '450px'
  }
};
//# sourceMappingURL=Lottie.theme.js.map